<template>
  <main>
    <div class="d-flex justify-space-between mb-2">
      <div class="d-flex justify-center align-center">
        <div class="img_title_bill_retrospect_all">
          <img src="@/assets/icon-restaurant-bill.png" />
        </div>
        <h2 class="ml-3">สร้างใบกำกับภาษี</h2>
      </div>
    </div>
    <v-container>
      <v-card class="py-10 px-16">
        <div class="d-flex justify-space-between">
          <div
            style="
              width: 30%;
              border-style: solid;
              border-width: 1px;
              border-radius: 5px;
            "
            class="d-flex flex-column align-center px-16 py-2"
          >
            <span style="color: #058dc2; font-weight: 500; font-size: 20px">
              ใบเสร็จรับเงิน / ใบกำกับภาษี
            </span>
            <span
              style="
                font-weight: 300;
                font-size: 15px;
                text-decoration: underline;
              "
            >
              ต้นฉบับ
            </span>
          </div>
          <div>
            <div>
              <span style="color: #058dc2; font-weight: 400; font-size: 15px">
                วันที่
              </span>
              <span style="font-weight: 400; font-size: 15px">08/05/2567</span>
            </div>
            <div>
              <span style="color: #058dc2; font-weight: 400; font-size: 15px">
                วันที่
              </span>
              <span style="font-weight: 400; font-size: 15px"
                >IV2024058000001</span
              >
            </div>
          </div>
        </div>
        <div class="d-flex justify-space-between align-center mt-8">
          <span
            >ห้างหุ้นส่วนจำกัด. ก๋างโต้งฟู๊ด (สำนักงานใหญ่)<br />
            เลขที่ 633/144 หมู่ 4 ต.หนองจ๊อม อ.สันทราย จ.เชียงใหม่ 50290<br />
            เลขประจำตัวผู้เสียภาษี 0-5035-60007-07-6
          </span>
          <img
            :src="taxDetail.invoiceDetaile.logo_image"
            style="width: 120px"
          />
        </div>

        <div class="mt-8 d-flex justify-space-between">
          <div class="d-flex">
            <span style="color: #058dc2"> ลูกค้า </span>
            <div class="ml-4">
              {{ taxDetail.invoiceDetaile.customer_name }}<br />
              {{ taxDetail.invoiceDetaile.address }}
            </div>
          </div>
          <div>
            เลขประจำตัวผู้เสียภาษี {{ taxDetail.invoiceDetaile.tax_number }}
          </div>
        </div>

        <div
          style="
            border-bottom: 2px solid #058dc2 !important;
            border-radius: 0px;
          "
          class="pb-4"
        >
          <v-row
            style="
              border-top: 2px solid #058dc2 !important;
              border-bottom: 2px solid #058dc2 !important;
              border-radius: 0px;
            "
            class="mt-8 mb-4"
          >
            <v-col cols="1" align="center">ลำดับ</v-col>
            <v-col cols="5" align="center">รายการ</v-col>
            <v-col cols="2" align="center">จำนวน</v-col>
            <v-col cols="2" align="right">ราคาต่อหน่วย</v-col>
            <v-col cols="2" align="right">จำนวนเงิน</v-col>
          </v-row>

          <!-- แสดงรายการอาหาร -->
          <div v-if="taxDetail.invoiceDetaile.type_show_data == 0">
            <v-row v-for="(item, i) in taxDetail.listnoBuffet" :key="item">
              <v-col
                cols="1"
                align="center"
                style="padding-top: 2px; padding-bottom: 2px"
                >{{ i + 1 }}</v-col
              >
              <v-col
                cols="5"
                align="left"
                style="padding-top: 2px; padding-bottom: 2px"
              >
                {{ item.name }} <br />
                {{ item.extra > 0 ? "-ท๊อปปิ้งเพิ่ม" : "" }}
              </v-col>
              <v-col
                cols="2"
                align="center"
                style="padding-top: 2px; padding-bottom: 2px"
                >{{ item.amount }}</v-col
              >
              <v-col
                cols="2"
                align="right"
                class="pr-12"
                style="padding-top: 2px; padding-bottom: 2px"
              >
                {{ item.extra ? item.extra.toFixed(2) : item.price.toFixed(2) }}
              </v-col>
              <v-col
                cols="2"
                align="right"
                class="pr-12"
                style="padding-top: 2px; padding-bottom: 2px"
              >
                {{ item.total_price.toFixed(2) }}
              </v-col>
            </v-row>
          </div>

          <v-row
            v-if="taxDetail.invoiceDetaile.type_show_data == 1"
            class="mb-1"
          >
            <v-col
              cols="1"
              align="center"
              style="padding-top: 2px; padding-bottom: 2px"
              >1</v-col
            >
            <v-col
              cols="5"
              align="left"
              style="padding-top: 2px; padding-bottom: 2px"
              >ค่าอาหารและเครื่องดื่ม</v-col
            >
            <v-col
              cols="2"
              align="center"
              style="padding-top: 2px; padding-bottom: 2px"
              >1</v-col
            >
            <v-col
              cols="2"
              align="right"
              class="pr-12"
              style="padding-top: 2px; padding-bottom: 2px"
            >
              {{ taxDetail.invoiceDetaile.total_price.toFixed(2) }}
            </v-col>
            <v-col
              cols="2"
              align="right"
              class="pr-12"
              style="padding-top: 2px; padding-bottom: 2px"
            >
              {{ taxDetail.invoiceDetaile.total_price.toFixed(2) }}
            </v-col>
          </v-row>
        </div>

        <div class="mt-4">
          <v-row>
            <v-col cols="8" class="pl-12">
              <br />
              <span v-if="taxDetail.invoiceDetaile.total_price >= 0">
                ({{
                  taxDetail.invoiceDetaile.total_price == 0
                    ? "ศูนย์บาทถ้วน"
                    : convertThaiBaht(
                        (
                          taxDetail.invoiceDetaile.total_price +
                          (taxDetail.invoiceDetaile.total_price * 7) / 100 +
                          (taxDetail.invoiceDetaile.total_price * 5) / 100
                        ).toFixed(2)
                      )
                }})<br /><br /><br />
                <span style="color: #058dc2"> การชำระเงิน : </span>
                {{
                  taxDetail.invoiceDetaile.payment_method == 0
                    ? "สด"
                    : taxDetail.invoiceDetaile.payment_method == 1
                    ? "โอน"
                    : taxDetail.invoiceDetaile.payment_method == 2
                    ? "โครงการรัฐ"
                    : "เดบิต / เครดิต"
                }}
              </span>
            </v-col>
            <v-col
              cols="2"
              align="right"
              class="pr-12"
              style="
                border-bottom: 1px solid #058dc2 !important;
                border-radius: 0px;
              "
            >
              รวมเงิน<br />
              มูลค่าไม่มีภาษี<br />
              ภาษี 7%<br />
              ค่าบริการ 5%<br />
              จำนวนเงินทั้งสิ้น<br />
            </v-col>
            <v-col
              cols="2"
              align="right"
              class="pr-12"
              style="
                border-bottom: 1px solid #058dc2 !important;
                border-radius: 0px;
              "
            >
              {{ taxDetail.invoiceDetaile.total_price.toFixed(2) }}<br />
              {{
                (
                  taxDetail.invoiceDetaile.total_price -
                  (taxDetail.invoiceDetaile.total_price * 7) / 100
                ).toFixed(2)
              }}
              <br />
              {{
                ((taxDetail.invoiceDetaile.total_price * 7) / 100).toFixed(2)
              }}
              <br />
              {{
                ((taxDetail.invoiceDetaile.total_price * 5) / 100).toFixed(2)
              }}
              <br />
              {{
                (
                  taxDetail.invoiceDetaile.total_price +
                  (taxDetail.invoiceDetaile.total_price * 7) / 100 +
                  (taxDetail.invoiceDetaile.total_price * 5) / 100
                ).toFixed(2)
              }}<br />
            </v-col>
          </v-row>
        </div>

        <div class="mt-4 mb-16">
          <v-row>
            <v-col cols="8"></v-col>
            <v-col
              cols="2"
              align="right"
              class="pr-12"
              style="
                border-bottom: 2px solid #058dc2 !important;
                border-radius: 0px;
              "
            >
              ส่วนลด <br />
              <span style="color: #058dc2"> ยอดชำระ </span>
            </v-col>
            <v-col
              cols="2"
              align="right"
              class="pr-12"
              style="
                border-bottom: 2px solid #058dc2 !important;
                border-radius: 0px;
              "
            >
              {{ taxDetail.invoiceDetaile.discount.toFixed(2) }} <br />{{
                (
                  taxDetail.invoiceDetaile.total_price +
                  (taxDetail.invoiceDetaile.total_price * 7) / 100 +
                  (taxDetail.invoiceDetaile.total_price * 5) / 100 -
                  taxDetail.invoiceDetaile.discount
                ).toFixed(2)
              }}
            </v-col>
          </v-row>
        </div>
      </v-card>

      <v-card class="py-10 px-16 mt-4">
        <h3 class="mb-2">ผู้ดำเนินการ</h3>
        <div class="d-flex justify-space-between align-end">
          <div class="mb-2">
            <span style="color: #058dc2"> ผู้สร้างใบกำกับภาษี </span>
            : {{ taxDetail.invoiceDetaile.create_taxinvoice_by_name }}<br />
            <span style="color: #058dc2"> วันที่ </span>
            <span class="mr-8">
              : {{ taxDetail.invoiceDetaile.create_taxinvoice_date }} น.
            </span>
          </div>
          <div>
            <div class="d-flex justify-end">
              <span style="color: #058dc2"> วันที่ </span> : 2 ครั้ง <br />
            </div>

            <div class="d-flex">
              <v-btn
                class="grad-primary-bg white--text titlefont_bill_retrospect_all mb-2 mr-4"
                height="50"
                @click="createTaxInvoice()"
              >
                แก้ไขใบกำกับภาษี
              </v-btn>
              <v-btn
                class="grad-primary-bg white--text titlefont_bill_retrospect_all mb-2"
                height="50"
              >
                <v-icon class="mr-2">mdi-printer</v-icon>
                พิมพ์ใบกำกับภาษี
              </v-btn>
            </div>
          </div>
        </div>
      </v-card>
    </v-container>
  </main>
</template>

<script>
import { HTTP } from "@/axios.js";
import THBText from "thai-baht-text";
export default {
  name: "createtaxinvoice",
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  data() {
    return {
      taxDetail: {},
    };
  },
  methods: {
    async getTaxData() {
      HTTP.get(`POS/table/invoice-detaile/${this.$route.params.id}`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.token}`,
        },
      })
        .then((response) => {
          if (response.data.successful === true) {
            this.taxDetail = response.data;
          }
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.$store.commit("logOutSuccess");
            this.$router.push("/login");
          }
        });
    },
    convertThaiBaht(number) {
      return THBText(number);
    },
    async createTaxInvoice() {
      HTTP.post(
        "POS/table/invoice/save-data-taxinvoice",
        {
          id: this.$route.params.id,
          create_taxinvoice_by_name: null,
          customer_name: this.taxDetail.invoiceDetaile.customer_name,
          tax_number: this.taxDetail.invoiceDetaile.tax_number,
          address: this.taxDetail.invoiceDetaile.address,
          district: this.taxDetail.invoiceDetaile.district, 
          amphoe: this.taxDetail.invoiceDetaile.amphoe, 
          province: this.taxDetail.invoiceDetaile.province,
          zipcode: this.taxDetail.invoiceDetaile.zipcode,
          type_show_data: this.taxDetail.invoiceDetaile.type_show_data,
        },
        {
          headers: {
            Authorization: `Bearer ${this.$store.state.token}`,
          },
        }
      )
        .then((response) => {
          if (response.data.successful === true) {
            this.$router.push(`/createtaxinvoice/${this.$route.params.id}`);
          }
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.$store.commit("logOutSuccess");
            this.$router.push("/login");
          }
        });
    },
  },
  mounted() {
    this.getTaxData();
  },
};
</script>

<style>
s .border-head {
  border-top: 2px solid #058dc2 !important;
  border-bottom: 2px solid #058dc2 !important;
}
</style>
